


























import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { ICustomStylingClass } from '@/components/Globals/types/custom.t';
import { FocusTrap } from 'focus-trap-vue';

@Component({
  components: {
    FocusTrap,
  }
})
export default class CustomModal extends Vue {
  viewportHeight: number = 0;
  isActive = false as boolean;

  @Prop({ default: true })
  clickToClose!: boolean;

  @Prop()
  customClass?: ICustomStylingClass[];

  @Prop()
  customRef?: string;

  @Prop({ default: false })
  fullHeight!: boolean;

  @Prop()
  height?: string | number;

  @Prop({ default: 500 })
  maxWidth!: number;

  @Prop({ default: 'modalwrapper' })
  name!: string;

  @Prop({ default: false })
  scrollable!: boolean;

  @Prop()
  width?: string | number;

  @Prop()
  dialogDesc?: boolean;

  @Prop()
  modalTitle?: string;

  get isIframe() {
    return this.$store.getters['utils/noEsiActive'] &&
      this.$store.getters['utils/isIframeSameOrigin'];
  }

  get isMobile() {
    return this.$store.getters['utils/returnScreenSize'].includes('mobile');
  }

  get modalHeight() {
    if (this.fullHeight && this.isIframe && this.isMobile) {
      return  window.parent.innerHeight;
    }

    if (this.fullHeight && this.isMobile) {
      return this.viewportHeight;
    }

    return this.height;
  }

  created() {
    this.updateViewportHeight();
    window.addEventListener('resize', this.updateViewportHeight);
    this.isActive = true;
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewportHeight);
  }

  @Emit('beforeOpen')
  beforeOpen() {}

  @Emit('beforeClose')
  beforeClose() {}

  @Emit('closed')
  closed() {}

  updateViewportHeight() {
    this.viewportHeight = window.innerHeight;
  }
}
